export default __webpack_public_path__ + "static/media/address.94c262ad.svg";